import { Box, BoxProps, MaterialTextInput } from '@jfs/ui-new'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import ShowHidePassword from '../AadharNumberEditText/ShowHidePassword'

interface VidEditTextProps {
  onTextChanged: (value: string) => void
  label?: string
  error?: any
  initialVal?: string
  rightSideComponent?: React.ReactNode
}

const formatVidNumber = (value: string) => {
  return value?.replace(/ /g, '').replace(/.{4}(?=.)/g, '$& ')
}

export const VidEditText: FC<VidEditTextProps> = (props: VidEditTextProps) => {
  const [vid, setVid] = useState(props?.initialVal?.replace(/ /g, '').replace(/.{4}(?=.)/g, '$& ') ?? '')
  const [cursorPosition, setCursorPosition] = useState(0)
  const [errorMessage, setErrorMessage] = useState('')
  const [hidePassword, setHidePassword] = useState(true)

  useEffect(() => {
    setErrorMessage(props?.error ?? '')
  }, [props, props.error])

  const onValueChanged = (textValue: string) => {
    const isSpaceEntered = textValue.charAt(cursorPosition).trim() === ''
    textValue = formatVidNumber(textValue)

    if (textValue.length > formatVidNumber(vid).length) {
      //user has typed something

      if (!isNaN(+textValue.charAt(cursorPosition))) {
        //user has typed some thing
        if (textValue.charAt(cursorPosition).trim()) {
          const finalAadhaarCardNo =
            vid.slice(0, cursorPosition) + textValue.charAt(cursorPosition) + vid.slice(cursorPosition)

          setVid(formatVidNumber(finalAadhaarCardNo))
          setCursorPosition(cursorPosition + 1)
          onVidChange(formatVidNumber(finalAadhaarCardNo))
        } else if (!isNaN(+textValue.charAt(cursorPosition + 1))) {
          const finalAadhaarCardNo =
            vid.slice(0, cursorPosition) + textValue.charAt(cursorPosition + 1) + vid.slice(cursorPosition + 1)

          setVid(formatVidNumber(finalAadhaarCardNo))
          setCursorPosition(cursorPosition + 2)
          onVidChange(formatVidNumber(finalAadhaarCardNo))
        } else {
          setTimeout(() => setCursorPosition(cursorPosition), 20)
        }
      } else {
        setTimeout(() => setCursorPosition(cursorPosition), 10)
      }
    } else if (textValue.length < formatVidNumber(vid).length) {
      //some thing has being deleted
      if (textValue.charAt(cursorPosition - 1) !== ' ') {
        //removing deleted char from aadharNumberText
        const finalAadhaarCardNo = vid.slice(0, cursorPosition - 1) + vid.slice(cursorPosition)
        setVid(formatVidNumber(finalAadhaarCardNo))
        onVidChange(formatVidNumber(finalAadhaarCardNo))
      }
      setCursorPosition(cursorPosition - 1)
    } else {
      if (isSpaceEntered) {
        setTimeout(() => setCursorPosition(cursorPosition), 10)
      } else {
        setTimeout(() => setCursorPosition(cursorPosition - 1), 10)
      }
    }
  }

  const onVidChange = (vid: any) => {
    vid = vid.replace(/ /g, '')
    props.onTextChanged(vid)
  }
  const validateVid = () => {
    const aadharNum = vid.replace(/ /g, '').trim()
    if (aadharNum.length !== 16) {
      setErrorMessage('VID numbers should be 16 digit in length')
    } else {
      setErrorMessage('')
    }
  }
  const isPasswordVisible = (isVisible: boolean): void => {
    setHidePassword(isVisible)
  }
  const onSelectionChange = (event: any) => {
    setCursorPosition(event?.nativeEvent?.selection?.end ?? 0)
  }

  const getMaskedVid = () => {
    if (vid.length < 14) {
      return vid.replace(/[0-9]/g, 'X')
    } else {
      return vid.substring(0, 14).replace(/[0-9]/g, 'X') + vid.substring(14)
    }
  }

  return (
    <Box bg="WHITE" {...styles.boxContainer}>
      <MaterialTextInput
        value={hidePassword ? getMaskedVid() : vid}
        cursorPosition={cursorPosition}
        onChange={onValueChanged}
        testID="vid-input"
        placeholder={props?.label ?? ''}
        color={'BLACK_21'}
        maxLength={19}
        error={errorMessage}
        onBlur={validateVid}
        onSelectionChange={onSelectionChange}
        keyboardType="numeric"
        fontFamily={'jiotype-medium'}
        animatedColorValue="#DF9F39"
        tintColor="PRIMARY"
        rightComponent={
          <>
            {props?.rightSideComponent}
            <ShowHidePassword
              isDisabled={false}
              isPasswordVisible={isPasswordVisible}
              showPassword={hidePassword}
              hide={vid.length === 0}
            />
          </>
        }
        touched
      />
    </Box>
  )
}

const styles = {
  boxContainer: {
    height: 72,
    width: '100%',
    alignContent: 'center',
    alignItems: 'center',
  } as BoxProps,
}
